import { computed, useScript } from '#imports'

export const useGooglePayScript = () => {
    const script = useScript({
        id: 'js-google-pay-sdk',
        src: 'https://pay.google.com/gp/p/js/pay.js',
        crossorigin: false,
    }, {
        trigger: 'manual',
    })

    const isLoaded = computed(() => script.status.value === 'loaded')

    return { ...script, isLoaded }
}
